// extracted by mini-css-extract-plugin
export default {"Coder":"Coder_Coder__4CBg8"};